import { RadioSelectedItem } from './types';

export const getActiveRadio: <ValueType extends string | number>(
  options: RadioSelectedItem<ValueType>[],
  value: RadioSelectedItem<ValueType>['value'],
) => RadioSelectedItem<ValueType> = (options, value) => options.find((option) => option.value === value) || options[0];
